import { Pipe, PipeTransform, inject } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Pipe({
  name: "safeHtml",
  standalone: false
})
export class SafeHtmlPipe implements PipeTransform {
  private readonly domSanitizier = inject(DomSanitizer);

  transform(value: string): SafeHtml {
    return this.domSanitizier.bypassSecurityTrustHtml(value);
  }
}
